import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import useAxios from '../../Hooks/useAxios';
import { getActiveProcesses } from "../../Components/RMCActiveProcess/RMCActiveProcess";
//import { subtractWorkingDays } from "../../Utils/date.util.js";
import { getWorkingDaysDifference } from "../../Utils/date.util.js";
import { STATUS_RESOLVED } from "../../Constants/Global";

/**
 * Component for displaying the top metric cards in the Reports view.
 * Currently in placeholder state.
 * * @component
 */

//$$ Convierte "aaaa-mm-dd" en un Date local a medianoche
const parseISOString = (dateString) => {
    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
};


 //$$ Media de dias entre el inicio de la tarea de orden 1 y la resolucion del proceso.
 //$$ Devuelve null si ningun proceso tiene resolved_at, para que se use el calculo anterior.
 const getResolvedDurationAverage = (dataSubprocesses, dataProcesses, dataFiltered ) => {
     if (!Array.isArray(dataProcesses) || !Array.isArray(dataSubprocesses)) return null;

     const aResolvedDays = [];

     //$$ Solo los procesos presentes en la lista filtrada
     const visibleLabels = new Set(
         Array.isArray(dataFiltered) ? dataFiltered.map((row) => row.label) : []);

     dataProcesses.forEach((process) => {

        if (!visibleLabels.has(process.id)) return;

         if (!process.resolvedAt) return;

         if (process.statusId !== STATUS_RESOLVED) return;

         //$$ Todas las tareas del mismo orden comparten inicio, asi que basta encontrar una
         const firstSubprocess = dataSubprocesses.find((row) =>
             row.label === process.id
             && Number(row.subprocessOrder) === 1
             && row.inProcessAt);

         if (!firstSubprocess) return;

         //const duration = Number(firstSubprocess.duration) || 0;


         const startDate = parseISOString(firstSubprocess.inProcessAt);

         //$$ Dias laborables entre la entrada en curso y la resolucion
         const iNumberDays = getWorkingDaysDifference(
                     parseISOString(firstSubprocess.inProcessAt),
                     parseISOString(process.resolvedAt));

         if (iNumberDays > 0) aResolvedDays.push(iNumberDays);
     });

     if (aResolvedDays.length === 0) return null;

     return Average(aResolvedDays);
 };

function isEarlier(dateStr1, dateStr2) {
  // Convertimos los strings "aaaa-mm-dd" a objetos Date
  const date1 = new Date(dateStr1);
  const date2 = new Date(dateStr2);

  // Comparamos
  if (date1 < date2) {
    return 1; // la primera es anterior
  } else {
    return 0; // no lo es
  }
}

const daysBetween = (date1, date2) => {
  const parseDate = (str) => {
    const [year, month, day] = str.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  const d1 = parseDate(date1);
  const d2 = parseDate(date2);

  const diffTime = d2 - d1; // diferencia en milisegundos

  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};


const Average = (array) => {
  if (!array || array.length === 0) return 0;

    //const suma = numeros.reduce((acc, num) => acc + num, 0);
  const add = array.reduce((acc, num) => acc + num, 0);
  return add / array.length;
};


//$$ card text
const text1 = "Processes on time/let";
const text2 = "Average onboarding time";
const text3 = "Critical point";

let endProcessDate = "";
let earlierEndDate = "";
let ProcessDAte = "";
let index = 0;

//$$ Getting process from api
 const GetProcesses = (dataFiltered) => {


    const { data, isLoading, error } = useAxios("allSubprocessesDetails");
    const { data: dataProcesses } = useAxios("processes");

    let text1 = "";
    let text2 = "";
    let text3 = "";

    let iNumberDays = 0;
    let aDurationAverage = [];
    let activeProcesses = getActiveProcesses();



        //$$ Calculo sobre procesos resueltos; si no hay ninguno, cae al calculo anterior
            const resolvedAverage = getResolvedDurationAverage(data, dataProcesses, dataFiltered);

            //CC MOD 2026-10-13 16:26
            //$$ data is a process array
            //if (data && Array.isArray(data)) {
            if (resolvedAverage !== null)
                text2 = resolvedAverage.toFixed(1);

            else if (data && Array.isArray(data)) {

                let iNumActiveProcesses = 0;
                let iNumLateProcesses = 0;
                const today = new Date();

               //$$ Loop for every active process in data
               activeProcesses.forEach((process)  => {


                     //Loop for every subprocess
                     data.forEach((row)=> {

                        //console.log("---index:", index);

                         if (row.label === process.id) {

                            //$$ Finding the earliest pending subprocess
                               if (index == 0 || (isEarlier(row.endDate, earlierEndDate)) == 1)
                               {
                                       earlierEndDate = row.endDate;

                               }
                               index ++;
                         }
                    });

                    index = 0;


                    iNumberDays = daysBetween(earlierEndDate, process.strEndDate);
                    //console.log("---earlierEndDate:", earlierEndDate);
                    //console.log("---strEndDate:", process.strEndDate);

                    if (iNumberDays > 0)
                    {
                        aDurationAverage.push(iNumberDays);
                        console.log(aDurationAverage);
                    }

                    earlierEndDate = ""

               });

               const iDuration = Average(aDurationAverage);

               text2 = iDuration.toFixed(1);
            }


    //$$ data is a process array
    //if (data && Array.isArray(data)) {
//
    //    let iNumActiveProcesses = 0;
    //    let iNumLateProcesses = 0;
    //    const today = new Date();
//
    //   //$$ Loop for every active process in data
    //   activeProcesses.forEach((process)  => {
//
//
    //         //Loop for every subprocess
    //         data.forEach((row)=> {
//
    //            //console.log("---index:", index);
//
    //             if (row.label === process.id) {
//
    //                //$$ Finding the earliest pending subprocess
    //                   if (index == 0 || (isEarlier(row.endDate, earlierEndDate)) == 1)
    //                   {
    //                           earlierEndDate = row.endDate;
//
    //                   }
    //                   index ++;
    //             }
    //        });
//
    //        index = 0;
//
//
    //        iNumberDays = daysBetween(earlierEndDate, process.strEndDate);
    //        //console.log("---earlierEndDate:", earlierEndDate);
    //        //console.log("---strEndDate:", process.strEndDate);
//
    //        if (iNumberDays > 0)
    //        {
    //            aDurationAverage.push(iNumberDays);
    //            console.log(aDurationAverage);
    //        }
//
    //        earlierEndDate = ""
//
    //   });
//
    //   const iDuration = Average(aDurationAverage);
//
    //   text2 = iDuration.toFixed(1);
    //}


    //$$ Emptying array and removing references
    activeProcesses = [];
    activeProcesses = null;

    return { text1, text2, text3 };
 }


const RMCDurationAverage = ({ data }) => {

  const { text1, text2, text3 } = GetProcesses(data);
   const getCard1Text = () => text1;
   const getCard2Text = () => text2;
   const getCard3Text = () => text3;

  // functions array
  const cardFunctions = [getCard2Text];

  //$$ Cards number 1 per function
  const cardNumber = cardFunctions.length;

  return (

  <div
        style={{
          display: 'grid',
          // This will change the width of the card dynamically for fixing the grid width
          gridTemplateColumns: `repeat(${cardNumber}, 1fr)`,

          gap: '16px'
        }}
      >
        { cardFunctions.map((fn,i) => (
          <Paper
            key={i}
            elevation={0}
            sx={{
              p: 2,
              border: '1px solid #ccc',
              display: 'flex',
              flexDirection: "column",
              //justifyContent: 'center',
              //alignItems: 'center',
              bgcolor: '#f9f9f9',
              borderRadius: 2,
              height: 120
            }}
          >

           <Typography
                  variant="h6"
                  sx={{ textAlign: "left", mb: 2 }}
                >
                  Average onboarding time
                </Typography>

          <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                  {/* Zona izquierda */}
                  <Typography variant="h2" sx={{ textAlign: "left", fontWeight: "bold", }}>
                    {fn()}
                  </Typography>

                  {/* Zona derecha */}
                  <div
                            style={{
                              display: "flex",
                              flexDirection: "column", // apila verticalmente
                              justifyContent: "flex-end", // empuja hacia abajo
                              alignItems: "flex-start",       // centra horizontal dentro de este div


                            }}
                          >
                            <Typography variant="h50" >
                            days
                            </Typography>
                          </div>
                </div>

          </Paper>
        ))}
      </div>

  );
};

export default RMCDurationAverage;